module.exports = __webpack_public_path__ + "static/img/TAISEI.a3d7a7ed.png";